"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFormatter = void 0;
const build_uc_event_data_1 = require("./build-uc-event-data");
const models_1 = require("./models");
const build_business_event_data_1 = require("./build-business-event-data");
const build_error_1 = require("./build-error");
class EventFormatter {
    constructor(params) {
        this._params = params;
    }
    formatUCEvent(ucParams, ...args) {
        var _a;
        let eventType;
        let eventName = "UCEvent" /* CONSTS.UC_EVENT_NAME */;
        let message;
        let innerType;
        let durationInMS;
        if (typeof ucParams === 'string') {
            message = ucParams;
            innerType = "LogEvent" /* CONSTS.DEFAULT_INNER_TYPE */;
            eventType = [models_1.EventType.Log];
        }
        else {
            message = ucParams.message;
            durationInMS = ucParams.durationInMS;
            eventType = (_a = ucParams.eventType) !== null && _a !== void 0 ? _a : [models_1.EventType.Log];
        }
        let [params, customData, err] = args;
        params = params !== null && params !== void 0 ? params : {};
        customData = customData !== null && customData !== void 0 ? customData : {};
        const eventParams = Object.assign(Object.assign({}, this._params.predefinedParams), params);
        const eventHeader = this._buildEventHeader(eventName, eventType, eventParams);
        const error = (0, build_error_1.buildError)(err);
        const eventData = (0, build_uc_event_data_1.buildUCEventData)(message, innerType, durationInMS, Object.assign(Object.assign(Object.assign({}, this._params.predefinedCustomData), customData), error));
        const event = {
            eventHeader,
            eventData
        };
        let sessionData;
        let userData;
        if (eventParams.sessionData) {
            sessionData = eventParams.sessionData;
        }
        else if (this._params.builderParams.factoryParams.sessionData) {
            sessionData = this._params.builderParams.factoryParams.sessionData;
        }
        if (eventParams.userData) {
            userData = eventParams.userData;
        }
        else if (this._params.builderParams.factoryParams.userData) {
            userData = this._params.builderParams.factoryParams.userData;
        }
        sessionData && (event.sessionData = sessionData);
        userData && (event.userData = userData);
        return Object.freeze(event);
    }
    formatBusinessEvent(formatParams, ...args) {
        var _a;
        let eventType;
        let eventName;
        if (typeof formatParams === 'string') {
            eventName = formatParams;
            eventType = [models_1.EventType.Log];
        }
        else {
            eventName = formatParams.eventName;
            eventType = (_a = formatParams.eventType) !== null && _a !== void 0 ? _a : [models_1.EventType.Log];
        }
        let [params, customData, err] = args;
        params = params !== null && params !== void 0 ? params : {};
        customData = customData !== null && customData !== void 0 ? customData : {};
        const eventParams = Object.assign(Object.assign({}, this._params.predefinedParams), params);
        const eventHeader = this._buildEventHeader(eventName, eventType, eventParams);
        const error = (0, build_error_1.buildError)(err);
        let eventData = (0, build_business_event_data_1.buildBusinessEventData)(eventName, Object.assign(Object.assign(Object.assign({}, this._params.predefinedCustomData), customData), error));
        const event = {
            eventHeader,
            eventData
        };
        const { sessionData, userData } = eventParams;
        sessionData && (event.sessionData = sessionData);
        userData && (event.userData = userData);
        return Object.freeze(event);
    }
    _buildEventHeader(eventName, eventType, params) {
        const logVersionFormat = "v2" /* CONSTS.LOG_VERSION_FORMAT */;
        const { environment, target, sessionID } = this._params.builderParams.factoryParams.settings;
        const { systemID, versionNumber, buildNumber, serverName, ipv4, ipv6 } = this._params.builderParams.factoryParams.sender;
        const componentName = this._params.builderParams.componentName;
        const subComponentName = this._params.subComponentName;
        const { correlationID, targetOverride, businessCorrelationID, level = models_1.Level.information, appID, productPackageID, sequentialNumber } = params;
        const eventFormatterType = this._params.builderParams.factoryParams.type;
        const eventHeader = {
            correlationID,
            sessionID,
            level,
            environment,
            target: targetOverride ? targetOverride : target,
            logVersionFormat,
            eventType: {
                name: eventName,
                type: eventType
            },
            sender: {
                systemID,
                versionNumber,
                buildNumber,
                serverName,
                ipv4,
                ipv6,
                componentName,
                subComponentName
            }
        };
        switch (eventFormatterType) {
            case models_1.EventFormatterType.Client:
                eventHeader.clientDateTime = new Date().toISOString();
                break;
            case models_1.EventFormatterType.Server:
                eventHeader.serverDateTime = new Date().toISOString();
                break;
            default:
                break;
        }
        businessCorrelationID && (eventHeader.businessCorrelationID = businessCorrelationID);
        appID && (eventHeader.appID = appID);
        productPackageID && (eventHeader.productPackageID = productPackageID);
        sequentialNumber && (eventHeader.sequentialNumber = sequentialNumber);
        return eventHeader;
    }
}
exports.EventFormatter = EventFormatter;
//# sourceMappingURL=event-formatter.js.map